import {useMediaQuery} from '../hooks';

export function DesktopOnly({
  fallback = null,
  children,
}: {
  children: React.ReactElement;
  fallback?: React.ReactElement | null;
}) {
  const {md} = useMediaQuery();
  return md ? children : fallback;
}
